"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var base_service_1 = require("../base-service");
var alertminer_api_configuration_1 = require("../alertminer-api-configuration");
var operators_1 = require("rxjs/operators");
var i0 = __importStar(require("@angular/core"));
var i1 = __importStar(require("../alertminer-api-configuration"));
var i2 = __importStar(require("@angular/common/http"));
var ReplacementClientService = /** @class */ (function (_super) {
    __extends(ReplacementClientService, _super);
    function ReplacementClientService(config, http) {
        return _super.call(this, config, http) || this;
    }
    /**
     * @param params The `ReplacementClientService.GetReplacementSpecificsGETParams` containing the following parameters:
     *
     * - `YearId`:
     *
     * - `TrimId`:
     *
     * - `ModelId`:
     *
     * - `MakeId`:
     *
     * - `FilterByNew`:
     *
     * - `DealerId`:
     *
     * @return Success
     */
    ReplacementClientService.prototype.GetReplacementSpecificsGETResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        if (params.YearId != null)
            __params = __params.set('YearId', params.YearId.toString());
        if (params.TrimId != null)
            __params = __params.set('TrimId', params.TrimId.toString());
        if (params.ModelId != null)
            __params = __params.set('ModelId', params.ModelId.toString());
        if (params.MakeId != null)
            __params = __params.set('MakeId', params.MakeId.toString());
        if (params.FilterByNew != null)
            __params = __params.set('FilterByNew', params.FilterByNew.toString());
        if (params.DealerId != null)
            __params = __params.set('DealerId', params.DealerId.toString());
        var req = new http_1.HttpRequest('GET', this.rootUrl + "/api/Replacement/GetReplacementSpecifics", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param params The `ReplacementClientService.GetReplacementSpecificsGETParams` containing the following parameters:
     *
     * - `YearId`:
     *
     * - `TrimId`:
     *
     * - `ModelId`:
     *
     * - `MakeId`:
     *
     * - `FilterByNew`:
     *
     * - `DealerId`:
     *
     * @return Success
     */
    ReplacementClientService.prototype.GetReplacementSpecificsGET = function (params) {
        return this.GetReplacementSpecificsGETResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param params The `ReplacementClientService.GetReplacementUpDownGETParams` containing the following parameters:
     *
     * - `YearId`:
     *
     * - `TrimId`:
     *
     * - `ModelId`:
     *
     * - `MakeId`:
     *
     * - `DealerId`:
     *
     * @return Success
     */
    ReplacementClientService.prototype.GetReplacementUpDownGETResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        if (params.YearId != null)
            __params = __params.set('YearId', params.YearId.toString());
        if (params.TrimId != null)
            __params = __params.set('TrimId', params.TrimId.toString());
        if (params.ModelId != null)
            __params = __params.set('ModelId', params.ModelId.toString());
        if (params.MakeId != null)
            __params = __params.set('MakeId', params.MakeId.toString());
        if (params.DealerId != null)
            __params = __params.set('DealerId', params.DealerId.toString());
        var req = new http_1.HttpRequest('GET', this.rootUrl + "/api/Replacement/GetReplacementUpDown", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param params The `ReplacementClientService.GetReplacementUpDownGETParams` containing the following parameters:
     *
     * - `YearId`:
     *
     * - `TrimId`:
     *
     * - `ModelId`:
     *
     * - `MakeId`:
     *
     * - `DealerId`:
     *
     * @return Success
     */
    ReplacementClientService.prototype.GetReplacementUpDownGET = function (params) {
        return this.GetReplacementUpDownGETResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param params The `ReplacementClientService.SaveBulkReplacementsByDefaultdealeridPOSTParams` containing the following parameters:
     *
     * - `defaultDealerId`:
     *
     * - `request`:
     *
     * @return Success
     */
    ReplacementClientService.prototype.SaveBulkReplacementsByDefaultdealeridPOSTResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = params.request;
        var req = new http_1.HttpRequest('POST', this.rootUrl + ("/api/Replacement/SaveBulkReplacements/" + params.defaultDealerId), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param params The `ReplacementClientService.SaveBulkReplacementsByDefaultdealeridPOSTParams` containing the following parameters:
     *
     * - `defaultDealerId`:
     *
     * - `request`:
     *
     * @return Success
     */
    ReplacementClientService.prototype.SaveBulkReplacementsByDefaultdealeridPOST = function (params) {
        return this.SaveBulkReplacementsByDefaultdealeridPOSTResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param params The `ReplacementClientService.BulkDeletePOSTParams` containing the following parameters:
     *
     * - `trimIDs`:
     *
     * - `dealerID`:
     */
    ReplacementClientService.prototype.BulkDeletePOSTResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = params.trimIDs;
        if (params.dealerID != null)
            __params = __params.set('dealerID', params.dealerID.toString());
        var req = new http_1.HttpRequest('POST', this.rootUrl + "/api/Replacement/BulkDelete", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param params The `ReplacementClientService.BulkDeletePOSTParams` containing the following parameters:
     *
     * - `trimIDs`:
     *
     * - `dealerID`:
     */
    ReplacementClientService.prototype.BulkDeletePOST = function (params) {
        return this.BulkDeletePOSTResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param id undefined
     * @return Success
     */
    ReplacementClientService.prototype.ByIdGETResponse = function (id) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('GET', this.rootUrl + ("/api/Replacement/" + id), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param id undefined
     * @return Success
     */
    ReplacementClientService.prototype.ByIdGET = function (id) {
        return this.ByIdGETResponse(id).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param id undefined
     */
    ReplacementClientService.prototype.ByIdDELETEResponse = function (id) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('DELETE', this.rootUrl + ("/api/Replacement/" + id), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param id undefined
     */
    ReplacementClientService.prototype.ByIdDELETE = function (id) {
        return this.ByIdDELETEResponse(id).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param ids undefined
     * @return Success
     */
    ReplacementClientService.prototype.GetManyGETResponse = function (ids) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        (ids || []).forEach(function (val) { if (val != null)
            __params = __params.append('ids', val.toString()); });
        var req = new http_1.HttpRequest('GET', this.rootUrl + "/api/Replacement/GetMany", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param ids undefined
     * @return Success
     */
    ReplacementClientService.prototype.GetManyGET = function (ids) {
        return this.GetManyGETResponse(ids).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param data undefined
     */
    ReplacementClientService.prototype.PUTResponse = function (data) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = data;
        var req = new http_1.HttpRequest('PUT', this.rootUrl + "/api/Replacement", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param data undefined
     */
    ReplacementClientService.prototype.PUT = function (data) {
        return this.PUTResponse(data).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param data undefined
     * @return Success
     */
    ReplacementClientService.prototype.POSTResponse = function (data) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = data;
        var req = new http_1.HttpRequest('POST', this.rootUrl + "/api/Replacement", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param data undefined
     * @return Success
     */
    ReplacementClientService.prototype.POST = function (data) {
        return this.POSTResponse(data).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    ReplacementClientService.GetReplacementSpecificsGETPath = '/api/Replacement/GetReplacementSpecifics';
    ReplacementClientService.GetReplacementUpDownGETPath = '/api/Replacement/GetReplacementUpDown';
    ReplacementClientService.SaveBulkReplacementsByDefaultdealeridPOSTPath = '/api/Replacement/SaveBulkReplacements/{defaultDealerId}';
    ReplacementClientService.BulkDeletePOSTPath = '/api/Replacement/BulkDelete';
    ReplacementClientService.ByIdGETPath = '/api/Replacement/{id}';
    ReplacementClientService.ByIdDELETEPath = '/api/Replacement/{id}';
    ReplacementClientService.GetManyGETPath = '/api/Replacement/GetMany';
    ReplacementClientService.PUTPath = '/api/Replacement';
    ReplacementClientService.POSTPath = '/api/Replacement';
    ReplacementClientService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReplacementClientService_Factory() { return new ReplacementClientService(i0.ɵɵinject(i1.AlertminerApiConfiguration), i0.ɵɵinject(i2.HttpClient)); }, token: ReplacementClientService, providedIn: "root" });
    return ReplacementClientService;
}(base_service_1.BaseService));
exports.ReplacementClientService = ReplacementClientService;
